/// <reference path="../../app.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { DsgvoAuskunftRequestApi } from "../../../../../shared/models/generated/MitgliedschaftDsgvoAuskunftRequestApi";
import { BasicApplicationUrlBuilder } from "../../../../../shared/services/BasicApplicationUrlBuilder";
import { AppFormModel } from "../models/AppFormModel";

export class AppApiService {

	private readonly options: BasicAppOptions<LocalAppDefinition>;
	private readonly applicationUrlBuilder: BasicApplicationUrlBuilder<LocalAppDefinition>;

	constructor(options: BasicAppOptions<LocalAppDefinition>) {
		this.options = options;
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(this.options);
	}

	public getVorgangsnummer(formId: string,
		successCallback: (data: ApiResponse<string>) => void,
		errorCallback: () => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: AppUtils.Url.updateUrlParameter({ FormId: formId }, this.applicationUrlBuilder.fullUrl(this.options.app.apiprocessid))
		}, successCallback, errorCallback);
	}

	public getSubmissionDate(formModel: AppFormModel, storeSubmissionDate: () => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apidatenow)
		}, (data: ApiResponse<string>) => {
			this.handleStoreSubmissionDateSuccessCallback(formModel, data.Data, storeSubmissionDate);
		});
	}

	public sendConfirmation(requestModel: DsgvoAuskunftRequestApi,
		successCallback: (data: ApiResponse<boolean>, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		T.Utils.Auth.getBearerToken((token: string) => {
			const options = {
				method: 'POST',
				url: this.applicationUrlBuilder.fullUrl(this.options.app.apidsgvoreport),
				headers: {
					Authorization: `Bearer ${token}`
				},
				data: requestModel.toJsonString()
			};
			AppUtils.Ajax.fragment(options, successCallback, errorCallback);
		});
	}

	private handleStoreSubmissionDateSuccessCallback(formModel: AppFormModel, data: string, storeSubmissionDate: () => void): void {
		const date = new Date(data);
		formModel.SubmissionDate = moment(date).format("DD.MM.YYYY HH:mm");
		storeSubmissionDate();
	}

	public checkOnlineCustomer(successCallback: (data: ApiResponse<any>) => void, errorCallback: () => void): void {
		T.Utils.Auth.getBearerToken((token: string) => {
			const options = {
				method: 'GET',
				url: this.applicationUrlBuilder.fullUrl(this.options.app.apiistreineronlinekunde),
				headers: {
					Authorization: `Bearer ${token}`
				}
			};
			AppUtils.Ajax.fragment(options, successCallback, errorCallback);
		});
	}
}